import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { plainToClass } from 'class-transformer';

import { GrowlService } from '@app/core';
import { DialogStyle40 } from '@app/shared/classes/common';
import { Template, TemplateRequest } from './template';
import { TemplateDataService } from './template-data.service';
import { Transaction } from '../enums/txn-type.enum';
import { PurchaseRequisition } from "@app/procurement/purchase-requisition/purchase-req";
import {CommonTransformationService} from "@app/shared/services/common-transformation.service";
import {SelectItem} from "primeng/api";

@Component({
  selector: 'app-template',
  templateUrl: './template.component.html',
  styleUrls: ['./template.component.css'],
  providers: [TemplateDataService]
})
export class TemplateComponent implements OnInit {

  DialogStyle40 = DialogStyle40;

  loadDialog: boolean = false;            // flag for displaying add button in the dialog
  saveDialog: boolean = false;            // flag for displaying save button in the dialog
  showTemplateDialog: boolean = false;    // flag for displaying dialog
  templateOptions: SelectItem[] = [];
  templates: Template[] = [];               // a list of templates retrieved from backend
  selectedTemplate: Template;               // selected template for loading
  suggestedTemplates: Template[] = [];      // a list of template for auto complete
  templateName: string;                       // template name for saving
  templateData: any;                          // template data to save

  @Input() txnType: Transaction;

  private _request: TemplateRequest;
  @Input()
  set request(value: TemplateRequest) {
    if (value) {
      this._request = value;
      if (this._request.request === 'load') {
        this.getTemplate();
        this.selectedTemplate = null;
        this.loadDialog = true;
        this.showTemplateDialog = true;
      } else if (this._request.request === 'save') {
        this.loadDialog = false;
        this.selectedTemplate = this._request.template;
        this.showTemplateDialog = true;
      }
    }
  }
  get request(): TemplateRequest {
    return this._request;
  }

  @Output() handler: EventEmitter<Template | PurchaseRequisition> = new EventEmitter();


  constructor (private growl: GrowlService, private dataService: TemplateDataService,  private transform: CommonTransformationService ) {
  }

  ngOnInit() {
  }

  cancel() {
    this.selectedTemplate = null;
    this.showTemplateDialog = false;
  }

  emitTemplate() {
    if (this.txnType == Transaction.PurchaseRequisition) {
      this.dataService.getPurchaseReqTemplateByPRId(this.selectedTemplate.purchaseReqId).subscribe(data => {
        this.handler.emit(plainToClass(PurchaseRequisition, data as PurchaseRequisition));
      });
    } else {
      this.handler.emit(this.selectedTemplate);
    }
    this.selectedTemplate = null;
    this.loadDialog = false;
    this.showTemplateDialog = false;
  }

  saveTemplate(description: string) {
    this.selectedTemplate.description = description;
    this.dataService.saveTemplate(this.txnType, this.selectedTemplate)
      .subscribe(res => {
        this.growl.add('success', 'template saved successfully');
        console.debug('saved template response =  ' + JSON.stringify(res));
      });
    this.selectedTemplate = null;
    this.saveDialog = false;
    this.showTemplateDialog = false;
  }

  deleteTemplate() {
    if (this.selectedTemplate) {
      this.dataService.deleteTemplate(this.txnType, this.selectedTemplate.id).subscribe(res => {
        this.growl.add('success', 'Template deleted successfully');
        console.debug('delete template response =  ' + JSON.stringify(res));
      });
      this.selectedTemplate = null;
    }
  }

  private showLoadDialog() {
    this.loadDialog = true;
    this.showTemplateDialog = true;
  }

  private showSaveDialog() {
    this.loadDialog = false;
    this.showTemplateDialog = true;
  }

  private getTemplate() {
    this.dataService.getTemplate(this.txnType)
      .subscribe(res => {
        this.templates = plainToClass(Template, res.list);
        this.templateOptions = this.transform.convertToDropDown("description", res.list);
      });
  }

}
